import React, { useEffect, useState } from 'react';
import { Button, Card, Col, Container, Form, Row } from 'react-bootstrap';
import { BsDisplay, BsPalette } from 'react-icons/bs';

const Parametres: React.FC = () => {
  const [theme, setTheme] = useState(() => localStorage.getItem('theme') || 'dark');

  useEffect(() => {
    document.documentElement.setAttribute('data-bs-theme', theme);
  }, [theme]);

  const save = () => localStorage.setItem('theme', theme);

  return (
    <Container fluid className="py-5">
      <h1 className="display-4 mb-3">Paramètres d'affichage</h1>
      <p className="lead text-muted mb-4">Personnalisez votre expérience utilisateur.</p>
      <Card className="shadow-sm">
        <Card.Header>
          <BsPalette className="text-primary me-2" /> Apparence
        </Card.Header>
        <Card.Body>
          <Row>
            <Col md={6}>
              <Form.Label><BsDisplay className="me-2" />Thème</Form.Label>
              <Form.Select value={theme} onChange={(event) => setTheme(event.target.value)}>
                <option value="light">Clair</option>
                <option value="dark">Sombre</option>
              </Form.Select>
            </Col>
          </Row>
        </Card.Body>
      </Card>
      <div className="d-flex justify-content-end mt-4">
        <Button onClick={save}>Enregistrer les préférences</Button>
      </div>
    </Container>
  );
};

export default Parametres;
